// import { useState, useEffect } from "react";
// import axios from "axios";
// import config from "../../../Helpers/config.json";
// import { errorMessages } from "../../../Helpers/ErrorMessages";
// import { useReusableNewWholeSales } from "./useReusableNewWholeSales";
// import { history } from "../../../Helpers/history";   // ← Import this


// export const useEditProformaInvoice = (actions, invoice_id) => {
//     const user = JSON.parse(sessionStorage.getItem('user'));
//     const user_id = user?.user_id || 1;

//     const [submitted, setSubmitted] = useState(false);
//     const [isSubmitted, setIsSubmitted] = useState('idle');
//     const [isBlocking, setIsBlocking] = useState(false);

//     // Reuse the common logic
//     const { stateFunctions, stateVariables } = useReusableNewWholeSales(
//         actions, 
//         invoice_id, 
//         true,           // ← Important: This flag probably tells the reusable hook it's for Edit
//         ''              // saletype (empty for proforma edit)
//     );

//     const {
//         customer,
//         rows,
//         totals,
//         state,
//         // initialState, // if needed
//     } = stateVariables;

//     const { 
//         setRows, 
//         setCustomer, 
//         setTotals,
//         // ... other setters you might need
//     } = stateFunctions;

//     // ====================== LOAD EXISTING DATA ======================
//     useEffect(() => {
//         if (!invoice_id) return;

//         const loadProforma = async () => {
//             try {
//                 const res = await axios.get(
//                     `${config.epharmUrl}/Cinvoice/proforma_invoice/${invoice_id}`,
//                     // { headers: { user_id } }
//                 );

//                 if (res.data.status === 200) {
//                     const data = res.data.data;

//                     setCustomer({
//                         customer_name: data.customer_name || "",
//                         customer_id: data.customer_id || ""
//                     });

//                     // Set invoice date
//                     // if (stateVariables.setState) {
//                         stateVariables.setState({
//                             invoice_date: data.date ? data.date.split('T')[0] : "",
//                             inva_details: data.memo || "",
//                         });
//                     // }

//                     const formattedRows = data.products?.map((p, index) => ({
//                         uuid_id: `edit-row-${index}`,
//                         product_id: p.product_id,
//                         product_name: p.product_name,
//                         product_rate: Number(p.rate || 0),
//                         product_quantity: Number(p.quantity || 0),
//                         total_price: Number(p.total_price || 0),
//                         total_stock: 0,
//                     })) || [];

//                     setRows(formattedRows);

//                     setTotals({
//                         grand_total_price: Number(data.total_amount || 0),
//                         n_total: Number(data.total_amount || 0),
//                     });
//                 }
//             } catch (error) {
//                 console.error("Load Error:", error);
//                 errorMessages(error, null, actions);
//             }
//         };

//         loadProforma();
//     }, [invoice_id, actions, user_id, setCustomer, setRows, setTotals]);

//     // // ====================== SAVE / UPDATE ======================
//     // const saveProformaInvoice = async (event) => {
//     //     event.preventDefault();
//     //     setSubmitted(true);

//     //     if (!customer?.customer_id) {
//     //         actions.snackbarActions.infoSnackbar("Please select a customer");
//     //         return;
//     //     }
//     //     if (!state?.invoice_date) {
//     //         actions.snackbarActions.infoSnackbar("Please select date");
//     //         return;
//     //     }
//     //     if (!rows?.length) {
//     //         actions.snackbarActions.infoSnackbar("Please add at least one product");
//     //         return;
//     //     }

//     //     setIsSubmitted('pending');
//     //     setIsBlocking(true);

//     //     const bill_details = rows.map(row => ({
//     //         product_id: row.product_id,
//     //         quantity: Number(row.product_quantity),
//     //         rate: Number(row.product_rate),
//     //         total_price: Number(row.total_price),
//     //     }));

//     //     try {
//     //         const response = await axios.put(
//     //             `${config.epharmUrl}/Cinvoice/proforma_invoice/update/${invoice_id}`,
//     //             {
//     //                 customer_id: Number(customer.customer_id),
//     //                 total_amount: Number(totals.grand_total_price),
//     //                 bill_details,
//     //                 invoice_date: state.invoice_date,
//     //             },
//     //             { headers: { user_id } }
//     //         );

//     //         if (response.data.status === 200) {
//     //             actions.snackbarActions.successSnackbar("Proforma Invoice updated successfully!");
//     //         }
//     //     } catch (error) {
//     //         errorMessages(error, null, actions);
//     //     } finally {
//     //         setIsSubmitted('resolved');
//     //         setIsBlocking(false);
//     //     }
//     // };
//     // ====================== SAVE / UPDATE PROFORMA INVOICE ======================
// const saveProformaInvoice = async (event) => {
//     event.preventDefault();
//     setSubmitted(true);

//     // Basic validation
//     if (!customer?.customer_id) {
//         actions.snackbarActions.infoSnackbar("Please select a customer");
//         return;
//     }
//     if (!state?.invoice_date) {
//         actions.snackbarActions.infoSnackbar("Please select invoice date");
//         return;
//     }
//     if (rows.length === 0) {
//         actions.snackbarActions.infoSnackbar("Please add at least one product");
//         return;
//     }

//     setIsSubmitted('pending');

//     const bill_details = rows.map(row => ({
//         product_id: row.product_id,
//         quantity: Number(row.product_quantity),
//         rate: Number(row.product_rate),
//         total_price: Number(row.total_price || row.product_quantity * row.product_rate),
//         discount: Number(row.discount || 0),
//         discount_amount: Number(row.discount_amount || 0),
//         batch_details_id: row.batch_details_id || null,
//     }));

//     try {
//         let response;

//         if (invoice_id) {
//             // === UPDATE ===
//             response = await axios.put(
//                 `${config.epharmUrl}/Cinvoice/proforma_invoice/update/${invoice_id}`,
//                 {
//                     customer_id: Number(customer.customer_id),
//                     total_amount: Number(totals.grand_total_price),
//                     memo: state.inva_details || "",
//                     bill_details,
//                     invoice_date: state.invoice_date,
//                     is_wholesale: "wholesale"
//                 },
//                 { headers: { user_id } }
//             );
//         } else {
//             // === CREATE ===
//             response = await axios.post(
//                 `${config.epharmUrl}/Cinvoice/insert_proforma_invoice`,
//                 {
//                     customer_id: Number(customer.customer_id),
//                     total_amount: Number(totals.grand_total_price),
//                     memo: state.inva_details || "",
//                     bill_details,
//                     invoice_date: state.invoice_date,
//                     is_wholesale: "wholesale"
//                 },
//                 { headers: { user_id } }
//             );
//         }

//         if (response.data.status === 200 || response.data.success) {
//             actions.snackbarActions.successSnackbar(
//                 invoice_id ? "Proforma Invoice updated successfully!" : "Proforma Invoice created successfully!"
//             );
//             history.push("/proforma-invoices");

            
//             // Optional: redirect after success
//             // history.push('/proforma-invoices');
//         }
//     } catch (error) {
//         console.error(error);
//         errorMessages(error, null, actions);
//     } finally {
//         setIsSubmitted('resolved');
//     }
// };

//     const handleCloseSnackbar = () => actions.snackbarActions.hideSnackBar();

//     return {
//         submitted,
//         stateVariables: {
//             ...stateVariables,
//             isBlocking,
//             // Override or add edit-specific handlers if needed
//             handleChangeRate: stateVariables.handleChangeRate || ((e, idx) => {
//                 // fallback if not provided by reusable
//             }),
//             handleChangeQuantity: stateVariables.handleChangeQuantity || ((e, idx) => {}),
//         },
//         stateFunctions: { 
//             ...stateFunctions, 
//             setIsBlocking 
//         },
//         isPending: isSubmitted === 'pending',
//         saveProformaInvoice,
//         handleCloseSnackbar,
//     };
// }; 

// src/Components/Invoice/CustomHooks/useEditProformaInvoice.js

import { useState, useEffect } from "react";
import axios from "axios";
import config from "../../../Helpers/config.json";
import { errorMessages } from "../../../Helpers/ErrorMessages";
import { useReusableNewWholeSales } from "./useReusableNewWholeSales";
import { history } from "../../../Helpers/history";

export const useEditProformaInvoice = (actions, invoice_id) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    const user_id = user?.user_id || 1;

    const [submitted, setSubmitted] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState('idle');
    const [isBlocking, setIsBlocking] = useState(false);

    const { stateFunctions, stateVariables } = useReusableNewWholeSales(
        actions, 
        invoice_id, 
        false, 
        ""
    );

    const {
        customer,
        rows,
        totals,
        state,
        // setState,           // ← Important: Get setState from reusable
    } = stateVariables;

    const { 
        setRows, 
        setCustomer, 
        setTotals,
        setState,
    } = stateFunctions;

    // ====================== LOAD EXISTING PROFORMA ======================
    useEffect(() => {
        if (!invoice_id) return;

        const loadProforma = async () => {
            try {
                const res = await axios.get(
                    `${config.epharmUrl}/Cinvoice/proforma_invoice/${invoice_id}`
                );

                if (res.data.status === 200) {
                    const data = res.data.data;

                    // Set Customer
                    setCustomer({
                        customer_name: data.customer_name || "",
                        customer_id: data.customer_id || ""
                    });

                    // Set Date & Memo
                    setState({
                        invoice_date: data.date ? data.date.split('T')[0] : "",
                        inva_details: data.memo || data.inva_details || "",
                    });

                    // Set Products
                    const formattedRows = (data.products || []).map((p, index) => ({
                        uuid_id: `edit-row-${index}`,
                        product_id: p.product_id,
                        product_name: p.product_name,
                        product_rate: Number(p.rate || 0),
                        product_quantity: Number(p.quantity || 0),
                        total_price: Number(p.total_price || 0),
                        discount: Number(p.discount || 0),
                        discount_amount: Number(p.discount_amount || 0),
                        total_stock: 0,
                        batch_details_id: p.batch_details_id || null,
                    }));

                    setRows(formattedRows);

                    setTotals({
                        grand_total_price: Number(data.total_amount || 0),
                        n_total: Number(data.total_amount || 0),
                    });
                }
            } catch (error) {
                console.error("Failed to load proforma:", error);
                errorMessages(error, null, actions);
            }
        };

        loadProforma();
    }, [invoice_id, actions, setCustomer, setRows, setTotals, setState]);

    // ====================== SAVE / UPDATE ======================
    const saveProformaInvoice = async (event) => {
        event.preventDefault();
        setSubmitted(true);

        if (!customer?.customer_id) {
            actions.snackbarActions.infoSnackbar("Please select a customer");
            return;
        }
        if (!state?.invoice_date) {
            actions.snackbarActions.infoSnackbar("Please select invoice date");
            return;
        }
        if (rows.length === 0) {
            actions.snackbarActions.infoSnackbar("Please add at least one product");
            return;
        }

        setIsSubmitted('pending');

        const bill_details = rows.map(row => ({
            product_id: row.product_id,
            quantity: Number(row.product_quantity),
            rate: Number(row.product_rate),
            total_price: Number(row.total_price),
            discount: Number(row.discount || 0),
            discount_amount: Number(row.discount_amount || 0),
        }));

        try {
            const response = await axios.put(
                `${config.epharmUrl}/Cinvoice/proforma_invoice/update/${invoice_id}`,
                {
                    customer_id: Number(customer.customer_id),
                    total_amount: Number(totals.grand_total_price),
                    memo: state.inva_details || "",
                    bill_details,
                    invoice_date: state.invoice_date,
                    is_wholesale: false,   // change if needed
                },
                { headers: { user_id } }
            );

            if (response.data.status === 200 || response.data.success) {
                actions.snackbarActions.successSnackbar("Proforma Invoice updated successfully!");

                // Navigate to list after success
                setTimeout(() => {
                    history.push("/proforma-invoices");
                }, 1500);
            }
        } catch (error) {
            console.error(error);
            errorMessages(error, null, actions);
        } finally {
            setSubmitted(false);
            setIsSubmitted('resolved');
        }
    };

    const handleCloseSnackbar = () => {
        actions.snackbarActions.hideSnackBar();
    };

    return {
        submitted,
        isPending: isSubmitted === 'pending',
        stateVariables: {
            ...stateVariables,
            isBlocking,
        },
        stateFunctions: { 
            ...stateFunctions, 
            setIsBlocking 
        },
        saveProformaInvoice,
        handleCloseSnackbar,
    };
};